import { type ReduxUser } from 'models';
import { canCreateTags } from './canCreateTags';

export const canSeeTags = ({ viewer, organizationId }: { viewer: ReduxUser; organizationId: string }) =>
  canCreateTags({ viewer, organizationId });
